import Vue from "vue";
import Vuex from "vuex";
import usersStore from "./store/user/index";
import employees from "./store/employee/index";
import instructions from "./store/instruction/index";
import vehicle from "./store/vehicle/index";
import packagesModel from "./store/packages/index";
import alertStore from "./alert/alert";
import APIStore from "./handleRequest/store";
import IO from "./store/io/index";
import place from "./services/place"; 
Vue.use(Vuex);
export default new Vuex.Store({
  // namespaced: true,
  state: {
    darkMode: false,
    drawer: null,
    geoPlace: [],
    publicSRC: [],
    readyGeo: false,
    cities: [],
    // typeModel: [],
    typePlace: [
      { title: "Package", type: 1 },
      { title: "Documents", type: 3 },
      // { title: "Other", type: 4 },
    ],
  },
  getters: {
    darkMode(state) {
      return state.darkMode;
    },
    getCities(state) {
      return state.cities;
    },
  },
  mutations: {
    changeDarkMode(state, payload) {
      state.darkMode = payload;
      $cookies.set("darkMode", payload);
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    SET_GEOPLACE(state, payload) {
      state.geoPlace = payload;
      // state.typeModel = payload;
    },
    SET_publicSRC(state, payload) {
      state.publicSRC = payload;
      state.cities = payload;

    },
  },
  actions: {
    changeDarkMode({ commit }, payload) {
      commit("changeDarkMode", payload);
    },
    getGeoPlace({ state, commit,dispatch }) {
      return new Promise((resolve, reject) => {
        place
          .list()
          .then((res) => {
            state.readyGeo = false
            if (res.status <= 200) {

              commit("SET_GEOPLACE", res.data.data.rows);
              state.readyGeo = true
              resolve(res);
            } else {
              reject(res);
            }
          })
          .catch((err) => {
            state.readyGeo = false
            commit("SET_GEOPLACE", []);
            dispatch("api/handleServiceException", { e: err }, { root: true });

          });
      });
    },
    getPublicSRCPlace({ state, commit }) {
      state.readyGeo = false
      return new Promise((resolve, reject) => {
        place
          .publicSRC()
          .then((res) => {
            state.readyGeo = false
            if (res.status <= 200) {
              state.readyGeo = true
              commit("SET_publicSRC", res.data.data);
              resolve(res);
            } else {
              reject(res);
              state.readyGeo = false
            }
          })
          .catch((err) => {
            commit("SET_publicSRC", []);
            state.readyGeo = false
          });
      });
    },
  },
  modules: {
    namespace: true,
    users: usersStore,
    employees: employees,
    alert: alertStore,
    api: APIStore,
    packages: packagesModel,
    instructions: instructions,
    IO: IO,
    vehicleStore:vehicle
  },
});
